// extracted by mini-css-extract-plugin
module.exports = {"component":"close_button_component__XA3BK","noBackground":"close_button_noBackground__RvAOk"};